import Swiper, { Autoplay, EffectFade, Pagination, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

/**
 * スライダー関連 Class
 */
export default class Slider {
	constructor() {
		this.homeSlider();
		this.reasonsSlider();
	}
	/**
	 * TOP メインスライダー
	 */
	homeSlider() {
		const swiper = new Swiper('.p-mainvisual__slider-container', {
			modules: [Autoplay, EffectFade, Pagination],
			loop: true,
			speed: 500,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			autoplay: {
				delay: 7000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.p-mainvisual__slider-pagination',
			},
		});
	};

	/**
	 * TOP REASONSスライダー
	 */
	reasonsSlider() {
		const swiper = new Swiper('.p-reasons__slider-container', {
			modules: [Autoplay, EffectFade, Pagination, Navigation],
			loop: true,
			speed: 500,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			autoplay: {
				delay: 6000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.p-reasons__slider-pagination',
				type: 'fraction',
				formatFractionCurrent: function (number) {
					return '0' + number;
				},
				formatFractionTotal: function (number) {
					return '0' + number;
				}
			},
			navigation: {
				nextEl: ".p-reasons__slider-next",
				prevEl: ".p-reasons__slider-prev",
			},
		});
	};
}
